// Document Page - Uses generic module initialization patterns
// Demonstrates the new streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { documentConfig } from './documentConfig';
import { createDocumentValidation } from './documentValidation';
// DocumentService no longer needed - using SWR hooks directly

/**
 * Initialize the document module using generic utilities
 * This replaces the old documentConfigInit.js pattern
 */
const { config: initializedConfig } = initializeModule(
  documentConfig,
  createDocumentValidation
);

/**
 * Create the DocumentsPage using the generic module page factory
 * This eliminates the need for a custom component wrapper
 */
const DocumentsPage = createModulePage(
  initializedConfig,
  {
    displayName: 'DocumentsPage',
    description: 'Document Management System - QMS Documents'
  }
);

export default DocumentsPage;
